import { getAppConfig, type AppConfig } from '@/config/appConfig.js';

export const createFirebaseConfig = (appConfig: AppConfig) => ({
  apiKey: appConfig.firebase.apiKey,
  authDomain: appConfig.firebase.authDomain,
  projectId: appConfig.firebase.projectId,
  storageBucket: appConfig.firebase.storageBucket,
  messagingSenderId: appConfig.firebase.messagingSenderId,
  appId: appConfig.firebase.appId,
  measurementId: appConfig.firebase.measurementId,
});

export const getFirebaseConfig = () => createFirebaseConfig(getAppConfig());
